import React from 'react'
import { Row, Col, Image } from 'react-bootstrap';
import { MINI_PANDA_RESUMEN, MAGIC_PANDA_RESUMEN, PRODUCTOS_RESUMEN } from '../../../images/images';

const images = {
    'mini-panda': MINI_PANDA_RESUMEN,
    'magic-panda': MAGIC_PANDA_RESUMEN,
}

export default function ProductGroup(props) {

    const isInterior = false;

    const groupTotal = Object.values(props.content).map(entry => (((!isInterior) ? entry.price : entry.price_interior) * entry.quantity)).reduce((acc, cur) => (acc + cur), 0);

    return (
        <Row className="service-row">
            <Col xs="4">
                <Image src={images[props.category.slug] || PRODUCTOS_RESUMEN} roundedCircle height={80}/>
                <div className="title">{props.category.name}</div>
            </Col>
            <Col xs="5" className="quantity">
                <ul>
                {props.content.map((entry) => (<li>{`${entry.quantity} ${entry.name}`}</li>))}
                </ul>
            </Col>
            <Col xs="3" className="price">
                <span>${groupTotal}</span>
            </Col>
        </Row>
    )
}
